import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { useMemo } from 'react';
const DEFAULT_SIZE_PX = 64;
const IMAGE_CSS = css `
  filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.2));
`;
export const MedalDisplay = ({ medalName, imageUrl, sizePx = DEFAULT_SIZE_PX }) => {
    const nonImageContainerCss = useMemo(() => css `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: ${sizePx}px;
      min-width: ${sizePx}px;
      height: ${sizePx}px;
      min-height: ${sizePx}px;
      opacity: 0.5;
    `, [sizePx]);
    if (!imageUrl) {
        return (_jsx("div", { css: nonImageContainerCss, "aria-label": `${medalName} Medal Image Placeholder`, "aria-hidden": true, children: _jsx(StarRoundedIcon, {}) }));
    }
    return _jsx("img", { src: imageUrl, css: IMAGE_CSS, width: sizePx, height: sizePx, alt: `${medalName} Medal Image` });
};
